import {Action, Selector, State, StateContext} from "@ngxs/store";
import {Methodology} from "@app/models/methodology.model";
import {map, tap} from "rxjs/operators";
import {DecisionsStateModel, SaveDecisions, SetDecision} from "@app/state/decisions.state";
import {MethodologyService} from "@app/services/methodology.service";

export class MethodologyStateModel {
  allPeople: Methodology[];
  allTypes: Methodology[];
}

export class GetAllMethodologyPeople {
  static readonly type = '[methodology] GetAllMethodologyPeople';

  constructor() {
  }
}

export class GetAllMethodologyTypes {
  static readonly type = '[methodology] GetAllMethodologyTypes';

  constructor() {
  }
}

@State<MethodologyStateModel>({
  name: 'methodology',
  defaults: {
    allPeople: [],
    allTypes: []
  }
})
export class MethodologyState {

  constructor(private MethodologyService: MethodologyService) {

  }

  @Selector()
  public static allPeople(state: MethodologyStateModel) {
    return state.allPeople;
  }

  @Action(GetAllMethodologyPeople)
  public getAllMethodologyPeople(ctx: StateContext<MethodologyStateModel>, action: GetAllMethodologyPeople) {
    return this.MethodologyService.getAllPeopleMethodology().pipe(
      map(res => {
        ctx.patchState({allPeople: res});
      })
    );
  }

  @Selector()
  public static allTypes(state: MethodologyStateModel) {
    return state.allTypes;
  }

  @Action(GetAllMethodologyTypes)
  public getAllMethodologyTypes(ctx: StateContext<MethodologyStateModel>, action: GetAllMethodologyTypes) {
    return this.MethodologyService.getAllMethodologyTypes().pipe(
      map(res => {
        ctx.patchState({allTypes: res});
      })
    );
  }

}
